<template>
	<button class="button style-4" :class="loading ? 'loading' : ''" @click.prevent.stop="startOnboarding"
	        v-if="!verified">
		<span class="inner">{{ $t('general.verify_identity') }}</span>
	</button>
	<button class="button style-1" :class="loading ? 'loading' : ''" @click.prevent.stop="startOnboarding" v-else>
		<span class="inner">{{ $t('general.identity_verified') }}</span>
	</button>
</template>

<script>
import EventBus from "@/eventBus";
import {Browser} from "@capacitor/browser";
import { trackEvent, trackOnlineService } from "@/analytics";

export default {
	name: "OnboardingBox",
	data() {
		return {
			loading: false,
			ocrLink: false,
			ocrUid: false,
			action: null,
			data: null,
		}
	},
	computed: {
		verified() {
			let user = this.$store.state.auth.user;

			return user.verified;
		},
		buttonText() {
			let user = this.$store.state.auth.user;
			if (!user.verified) {
				return this.$t('general.verify_identity');
			}

			return this.$t('general.verify_identity_again');
		}
	},
	methods: {
		ocrEvent(kind, extra = {}) {
			// zdroj OCR: this.action set => z online služby; inak samostatné overenie identity
			if (this.action) {
				const map = {
					started: 'online_service_identity_started',
					link_error: 'online_service_identity_link_error',
					abandoned: 'online_service_identity_abandoned',
					processing: 'online_service_identity_processing',
					verified: 'online_service_identity_verified',
					error: 'online_service_identity_error',
				};
				trackOnlineService(map[kind], this.data || {}, extra);
			} else {
				const map = {
					started: 'identity_verification_started',
					link_error: 'identity_verification_link_error',
					abandoned: 'identity_verification_abandoned',
					processing: 'identity_verification_processing',
					verified: 'identity_verification_success',
					error: 'identity_verification_error',
				};
				trackEvent(map[kind], Object.assign({ module: 'identity' }, extra));
			}
		},
		startOnboarding(data = false) {
			if (this.loading) {
				return false;
			}

			if (data){
				this.action = data.action;
				this.data = data.service;
			}

			this.loading = true;
			this.$clientLog.info('requesting onboarding link', { action: this.action, serviceId: this.data && this.data.id }, 'identity.onboarding');
			this.axios.post('/api/personal-documents/get-onboarding-link').then(async (response) => {
				this.loading = false;
				this.ocrLink = response.data.ocr_link;
				this.ocrUid = response.data.ocr_uid;

				this.$store.commit('SET_STOP_AUTOMATIC_LOGOUT');

				await Browser.open({
					url: this.ocrLink
				});

				this._openedBrowser = true;
				this.ocrEvent('started');

			}).catch((error) => {
				this.ocrEvent('link_error', {
					error_message: error && error.response && error.response.data ? error.response.data.message : (error && error.message),
					error_status: error && error.response ? String(error.response.status) : null,
				});
				this.$clientLog.error('get-onboarding-link failed', this.$clientLog.errorInfo(error), 'identity.onboarding');
				this.$swal.fire({
					icon: 'error',
					title: 'Oops',
					text: this.$t('general.default_error')
				});

				this.loading = false;
			});
		},
		verifyOnboarding() {
			if (!this.ocrUid) {
				this.ocrEvent('abandoned');
				this.$clientLog.warn('verify abandoned - no ocrUid', {}, 'identity.verify');
				return false;
			}

			const ocrUid = this.ocrUid;
			this.ocrUid = false;

			this.$store.commit('SET_APP_LOADING')
			this.axios.post('/api/personal-documents/verify', {
				ocr_uid: ocrUid
			}).then((response) => {
				this.ocrEvent('verified');
				this.$store.commit('UNSET_APP_LOADING');
				this.$swal.fire({
					icon: 'success',
					title: this.$t('general.thank_you'),
					text: this.$t('general.user_verified')
				});

				if (!this.$store.state.auth.user.intranet_data && response.data.user){
					this.$store.commit('SET_USER', response.data.user);
				}

				if(this.action){
					this.$clientLog.info('identity verified, re-dispatching action', { action: this.action }, 'identity.verify');
					this.$store.commit('SET_USER_VERIFIED', true);
					this.$store.dispatch(this.action, this.data);
					this.action = null;
					this.data = null;
				}

				this.$store.state.auth.user.verified = 1;
			}).catch((error) => {
				const code = error && error.response && error.response.data ? error.response.data.code : null;
				let kind = 'error';

				if (code === 'verification_not_started') {
					kind = 'abandoned';
				} else if (code === 'verification_pending') {
					kind = 'processing';
				}

				this.ocrEvent(kind, {
					error_message: error && error.response && error.response.data ? error.response.data.message : (error && error.message),
					error_status: error && error.response ? String(error.response.status) : null,
					error_code: code || null,
				});
				this.$clientLog.error('verify failed', this.$clientLog.errorInfo(error), 'identity.verify');
				this.$store.commit('UNSET_APP_LOADING');
				this.$swal.fire({
					icon: 'error',
					title: 'Oops',
					text: error.response.data.message
				});
			});
		},
	},
	mounted() {
		this._openedBrowser = false;
		Browser.addListener('browserFinished', () => {
			if (!this._openedBrowser) {
				return;
			}

			this._openedBrowser = false;
			this.$clientLog.info('browser finished', { hasOcrUid: !!this.ocrUid }, 'identity.onboarding');
			this.verifyOnboarding();
			this.$store.commit('UNSET_STOP_AUTOMATIC_LOGOUT');
		}).then(handle => {
			this._browserFinishedListener = handle;
		});
		EventBus.on('start-onboarding', this.startOnboarding);
	},
	destroyed() {
		if (this._browserFinishedListener) {
			this._browserFinishedListener.remove();
			this._browserFinishedListener = null;
		}
		EventBus.off('start-onboarding', this.startOnboarding);
	}
}
</script>

<style scoped>

</style>